import React, { FC } from 'react';
import { useHasAccessServices } from 'components/hooks/services/useBoardServices';
import { RequestAccess } from './RequestAccess';
import { Service } from 'services/ApiService/ServiceBoard/ServiceBoardApiClient';

interface IRequestAccessIfMissingProps {
    service: Service;
    useIcon?: boolean;
    buttonClass?: string;
}

export const RequestAccessIfMissing: FC<IRequestAccessIfMissingProps> = ({ service, useIcon, buttonClass }) => {
    const { hasAccessTo } = useHasAccessServices();
    const { serviceKey, url } = service;

    if (!serviceKey || hasAccessTo(serviceKey)) {
        return null;
    }

    return (
        <RequestAccess
            serviceKey={serviceKey}
            url={url || ''}
            useIcon={useIcon}
            buttonClass={buttonClass}
        />
    );
};
